export default {
  header: 'API Keys',
  subheader: 'API keys are used to gain programatic access to the API of Qmulus.\nEach key automatically inherits the permissions of your user and acts on behalf of your user.',
  qmulusApiUrl: 'Qmulus API URL',
  openApiSpecification: 'OpenAPI Specification',
};
